<script setup>
import { useI18n } from 'vue-i18n';
import { checkId } from '../composables/salesReviewReturnSections';

const props = defineProps({
  definition: { type: Object, required: true },
  item: { type: Object, default: null },
  options: { type: Array, default: () => [] },
  incomplete: { type: Boolean, default: false },
  readOnly: { type: Boolean, default: false },
  showErrors: { type: Boolean, default: false },
});

const emit = defineEmits(['checks', 'observation']);
const { t } = useI18n();
const selectedCheckIds = () => (props.item?.checks || []).map(checkId);
const updateChecks = event => {
  const ids = Array.from(event.target.selectedOptions, option => option.value);
  emit('checks', ids);
};
const updateObservation = event => emit('observation', event.target.value);
</script>

<template>
  <label class="grid gap-2 text-sm font-medium text-lais-text">
    <span>
      {{ definition.checksLabel
      }}{{ t('SALES.REVIEW.RETURN_FORM.REQUIRED_MARK') }}
    </span>
    <select
      multiple
      class="min-h-28 w-full rounded-lais-sm border bg-white p-2 text-sm"
      :class="
        showErrors && !item?.checks?.length
          ? 'border-lais-danger'
          : 'border-lais-border'
      "
      :value="selectedCheckIds()"
      :disabled="readOnly"
      @change="updateChecks"
    >
      <option
        v-for="option in options"
        :key="checkId(option)"
        :value="checkId(option)"
      >
        {{ option.name || option.nome }}
      </option>
    </select>
    <span class="text-xs font-normal text-lais-text-muted">
      {{ definition.checksPlaceholder }}
    </span>
    <span
      v-if="showErrors && !item?.checks?.length"
      class="text-xs text-lais-danger"
    >
      {{ t('SALES.REVIEW.RETURN_FORM.REQUIRED') }}
    </span>
  </label>
  <label class="grid gap-2 text-sm font-medium text-lais-text">
    <span>{{ definition.observationLabel }}</span>
    <textarea
      rows="3"
      class="w-full rounded-lais-sm border bg-white p-3 text-sm font-normal"
      :class="
        showErrors && !item?.observation?.trim()
          ? 'border-lais-danger'
          : 'border-lais-border'
      "
      :value="item?.observation"
      :placeholder="definition.observationPlaceholder"
      :disabled="readOnly"
      @input="updateObservation"
    />
    <span
      v-if="showErrors && !item?.observation?.trim()"
      class="text-xs text-lais-danger"
    >
      {{ t('SALES.REVIEW.RETURN_FORM.REQUIRED') }}
    </span>
  </label>
  <p v-if="showErrors && incomplete" class="text-sm text-lais-danger">
    {{ t('SALES.REVIEW.ERRORS.ITEM') }}
  </p>
</template>
